import { Component, inject, DestroyRef, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ColumnFilterComponent } from 'src/app/main/instances-mgmt/column-filter/column-filter.component';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTableDataSource } from '@angular/material/table';
import { ChangeDetectorRef } from '@angular/core';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { TimeDurationPipe } from 'src/app/pipes/timeDuration.pipe';
import { ActivatedRoute } from '@angular/router';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { DatePipe } from '@angular/common'
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { EnvironmentPaginatorComponent } from '../environment-paginator/environment-paginator.component';
import { EnvironmentTableComponent } from '../environment-table/environment-table.component';
import { ActivityService } from 'src/app/services/api/activity.service';
import { ActivityProgressService } from 'src/app/services/util/activity-progress.service';
import { catchError, forkJoin, map, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ThresholdDialogComponent } from 'src/app/components/threshold-dialog-component/threshold-dialog-component';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { toUtcString } from 'src/app/services/util/utils';
import { AvailabilityStatus } from 'src/app/models/availability-status';
import { DeploymentClass } from 'src/app/models/instance-class';
import { EnvironmentActivityPopupComponent } from './environment-activity-popup/environment-activity-popup.component';

@Component({
  selector: 'app-environment-activity',
  templateUrl: './environment-activity.component.html',
  styleUrl: './environment-activity.component.scss',
  providers: [
    TimeDurationPipe
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: false
})
export class EnvironmentActivityComponent {
  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
  @ViewChild(EnvironmentPaginatorComponent) paginatorRef: EnvironmentPaginatorComponent;
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  @Input() isExternalTenant: boolean = false;
  @Output() updateEnvHeader = new EventEmitter<any>();
  private destroyRef = inject(DestroyRef);

  showActivityLoader: boolean;
  isLogFailed: boolean;
  dataSourceLog: any;
  deploymentLogData: any;
  instanceId: string;
  selectedActions: any;
  activityDropdownsList: any;
  filterStartDate: any;
  filterEndDate: any;
  logData: any;
  previousSelectedActions: any;
  sortInfo: any;
  filteredColumns: any;
  showSpinner: boolean;
  logColumns: string[] = ['menu', 'action', 'startTime', 'finishTime', 'duration', 'success', 'failure', 'status', 'initiatedBy', 'jobId', 'arrow'];
  innerLogColumns: string[] = ['componentName', 'version', 'startTime', 'endTime', 'duration', 'status', 'arrow'];
  expandedElement: any;
  pageIndex = 0;
  paginationSize = 10;
  deploymentLog: any;
  filteredDeploymentLog: any;
  showPagination: boolean;
  dataSourceInnerLog: any;
  logPaginator = true;
  arrowClicked = false;
  addColor: any;
  actionOptions = [];
  showLoader = false;
  AvailabilityStatus = AvailabilityStatus;
  displayColumns = [
    {
      key: 'arrowClick',
      name: '',
      type: 'expand',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'action',
      name: 'INSTANCE_DETAILS.ACTION',
      type: 'text',
      location: true,
      drMode: true,
      shutdown: true,
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'startTime',
      name: 'INSTANCE_DETAILS.START_TIME',
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'finishTime',
      name: 'INSTANCE_DETAILS.END_TIME',
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'duration',
      name: 'INSTANCE_DETAILS.TOTAL_DURATION',
      type: 'duration',
      startKey: 'startTime',
      endKey: 'finishTime',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'successCount',
      name: 'INSTANCE_DETAILS.SUCCESS',
      type: 'count',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'failureCount',
      name: 'INSTANCE_DETAILS.FAILURE',
      type: 'count',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'jobId',
      name: 'INSTANCE_DETAILS.JOB_ID',
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'initiatedBy',
      name: 'INSTANCE_DETAILS.INITIATED_BY',
      type: 'userIcon',
      visible: true,
      disable: false,
      sortable: false
    },
    {
      key: 'status',
      name: 'INSTANCE_DETAILS.STATUS',
      type: 'status',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'activitySettings',
      name: '',
      type: 'settings'
    }
  ];

  innerTableColumns = [
    {
      key: 'name',
      name: translate('INSTANCE_DETAILS.COMPONENT_NAME'),
      componentType: true,
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'version',
      name: translate('INSTANCE_DETAILS.VERSION'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'start',
      name: translate('INSTANCE_DETAILS.START_TIME'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'end',
      name: translate('INSTANCE_DETAILS.END_TIME'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'duration',
      name: translate('INSTANCE_DETAILS.DURATION'),
      type: 'duration',
      startKey: 'start',
      endKey: 'end',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'status',
      name: translate('INSTANCE_DETAILS.STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: false
    }
  ];
  searchTerm: string = '';
  searchedResult = [];
  instance: any;

  constructor(public dateTimeFormatService: DateTimeFormatService,
    private cdr: ChangeDetectorRef,
    private instanceService: InstancesService,
    private toastrService: CustomToastrService,
    private timeDuration: TimeDurationPipe,
    private activatedRoute: ActivatedRoute,
    private sidenavService: SidenavService,
    public datePipe: DatePipe,
    private activityService: ActivityService,
    public activityProgressService: ActivityProgressService,
    private dialog: MatDialog
  ) {
  }



  ngOnInit(): void {
    this.showSpinner = true;
    this.getInstanceDetails();
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.activityDropdownsList = [{ title: 'Action' }, { title: 'Date' }];
    this.loadActivityLogs();
  }

  private getInstanceDetails(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.instanceService.getInstanceDetails(instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.instance = data;
        }
      },
      (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

loadActivityLogs(): void {
    this.showActivityLoader = true;
    this.activityService.getInstanceActivityLogs(this.instanceId).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(response => {
        const total = response?.total ?? 0;
        const pageSize = response?.size ?? 10;
        const totalPages = response?.pages ?? 1;
        const firstPageData = response?.data ?? response ?? [];

        if (totalPages <= 1) {
          this.processActivityLogs(firstPageData);
        } else {
          const pageRequests = Array.from({ length: totalPages - 1 }, (_, i) =>
          this.activityService.getInstanceActivityLogs(this.instanceId, i + 1, pageSize)
          );

          forkJoin(pageRequests).pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(responses => {
                const allData = [
                  ...firstPageData,
                  ...responses.flatMap(r => r?.data ?? [])
                ];
                this.processActivityLogs(allData);
              },
              error => this.handleActivityLogError(error)
            );
        }
      },
      error => this.handleActivityLogError(error)
    );
}

private processActivityLogs(rawList: any[]): void {
  this.showSpinner = false;
  this.showActivityLoader = false;
  this.isLogFailed = true;

  this.logData = rawList.map(item => ({
    ...item,
    contextId: item.id,
    action: item.operation,
    expectedDurationMs:item.expectedDurationMs,// item.stages?.find(s => !s.finishTime)?.expectedDurationMs,
    startTime: item.startTime ? toUtcString(item.startTime) : null,
    finishTime: item.finishTime ? toUtcString(item.finishTime) : null,
    successCount: 0,
    failureCount: 0,
    initiatedBy: item.initiatedBy || '-',
    components: [],
    innerLoading: false,
    arrowClick: false
  }));

  let index = -1;
  this.logData?.forEach(item => {
    index++;
    const activityLog = true;
    if (item?.action === 'start' && this.logData[index - 1]?.action === 'stop') {
      item.shutdown = this.timeDuration.transform(
        item.startTime, this.logData[index - 1].finishTime, undefined, activityLog
      );
    }
  });

  this.logData?.forEach(item => {
    if (!this.actionOptions.find(opt => opt.value === item.action)) {
      this.actionOptions = [...this.actionOptions, { value: item.action, selected: false }];
    }
    this.activityDropdownsList[0].options = this.actionOptions;
  });

  this.deploymentLogData = this.logData;
  this.dataSourceLog = this.deploymentLogData;
  this.onLogTabChange();
  this.prefetchActivityCounts();
}

private prefetchActivityCounts(): void {
  if (!this.logData?.length) return;
  const detailRequests = this.logData.map(item =>
    this.activityService.getInstanceActivityLogsById(this.instanceId, item.contextId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(detail => ({ contextId: item.contextId, detail })),
        catchError(() => of({ contextId: item.contextId, detail: null }))  // don't fail all on one error
      )
  );
  forkJoin(detailRequests).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((results: { contextId: string; detail: any }[]) => {
      results.forEach(({ contextId, detail }) => {
        if (!detail) return;
        let components = (detail.stages ?? []).flatMap(stage =>
          (stage.components ?? []).map(c => ({
            ...c,
            name: c.name,
            version: c.version,
            start: c.start ? toUtcString(c.start) : null,
            end: c.end ? toUtcString(c.end) : null,
            status: c.status,
            componentType: c.componentType,
            health: c.health,
            stageType: stage.type,
            expectedDurationMs: c?.expectedDurationMs,
            location:  this.instance?.deploymentClass === DeploymentClass.A ? stage.location : null,
            showLocation: false
          }))
        ).sort((a, b) => {
          const order = {primary: 0,secondary: 1};
          return (order[a.location?.toLowerCase()] ?? 2) - (order[b.location?.toLowerCase()] ?? 2);
        });
        let lastLocationType: string | null = null;
        components.forEach((component: any) => {
          if (component?.location && component.location !== lastLocationType) {
            component.showLocation = true;
            lastLocationType = component.location;
          } 
        });
        const row = this.logData.find(r => r.contextId === contextId);
        if (row) {
          row.successCount = components.filter(c => c.status === 'success').length;
          row.failureCount = components.filter(c => c.status === 'failed').length;
          row.components = components;
        }
      });
      this.deploymentLogData = [...this.logData];
      this.onLogTabChange();
    });
}

private handleActivityLogError(error: any): void {
    this.showSpinner = false;
    this.isLogFailed = true;
    this.showActivityLoader = false;
    setTimeout(() => {
      const title = translate('ERRORS.SERVICE_AVAILABILITY');
      const message = error?.message ?? error?.error?.message ?? error?.errmsg ?? translate('SERVICE.INTERNAL_SERVER_ERROR');
      this.toastrService.errMessage(message, title);
    }, 500);
}
  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  addClassDuration(data, status): any {
    if (data.startsWith('00:')) {
      this.addColor = status === 'success' ? 'green' : 'white';
    } else {
      this.addColor = 'red';
    }
    return this.addColor;
  }

  dateFilter() {
    if (this.selectedActions) {
      this.activityDropdownsList[0]?.options?.map((item) => item.selected = false);
      this.selectedActions.forEach(item => {
        this.activityDropdownsList[0].options.find(option => option.value?.toLowerCase() === item?.toLowerCase()).selected = true;
      });
    } else {
      this.activityDropdownsList[0]?.options?.filter((item) => { item.selected = false; });
    }
    const data = {
      name: 'InstanceActivity',
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.activityDropdownsList,
      action: this.activityDropdownsList[0].options,
      dateCreated: this.instance?.dateCreated,
      startDate: this.filterStartDate,
      endDate: this.filterEndDate
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        if (filteredColumns[0].length === 0 && !filteredColumns[1]?.filteredStartDate && !filteredColumns[1]?.filterEndDate) {
          this.selectedActions = [];
          this.activityDropdownsList[0]?.options?.map((item) => item.selected = false);
          this.filterStartDate = undefined;
          this.filterEndDate = undefined;
          this.deploymentLogData = this.logData;
        }
        if (filteredColumns) {
          if (filteredColumns[0]?.length > 0 || filteredColumns[0] !== this.previousSelectedActions) {
            this.previousSelectedActions = filteredColumns[0];
            this.selectedActions = filteredColumns[0];
            this.deploymentLogData = filteredColumns[0].length > 0 ? this.logData?.filter(item => this.selectedActions?.includes(item?.action)) : this.logData;
          }
          if (filteredColumns[1] && filteredColumns[1].filteredStartDate && filteredColumns[1].filteredEndDate) {
            this.filterStartDate = filteredColumns[1].filteredStartDate;
            this.filterEndDate = filteredColumns[1].filteredEndDate;
            this.deploymentLogData = this.deploymentLogData.filter(item => this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
              this.datePipe.transform(item.finishTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd'));
          }
        }
        this.sortData(this.sortInfo ?? { active: 'startTime', direction: 'desc' });
      })
  }

  cancelFilter() {
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.deploymentLogData = this.selectedActions?.length > 0 ? this.logData?.filter(item => this.selectedActions?.includes(item?.action)) : this.logData;
    this.sortData(this.sortInfo ?? { active: 'startTime', direction: 'desc' });
  }

  cancelActionFilter(option) {
    this.selectedActions = this.selectedActions.filter(item => item !== option);
    this.activityDropdownsList[0].options.find(item => item.value === option).selected = false;
    if (this.filterStartDate && this.filterEndDate) {
      this.deploymentLogData = this.logData.filter(item =>
        this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
        this.datePipe.transform(item.finishTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd')
      );
    } else {
      this.deploymentLogData = this.logData;
    }
    if (this.selectedActions?.length > 0) {
      this.deploymentLogData = this.deploymentLogData?.filter(item => this.selectedActions?.includes(item?.action));
    }
    this.sortData(this.sortInfo ?? { active: 'startTime', direction: 'desc' });
  }

  clearAllFilters(): void {
  this.selectedActions = [];
  this.filterStartDate = undefined;
  this.filterEndDate = undefined;
  this.activityDropdownsList[0]?.options?.map((item) => item.selected = false);
  this.deploymentLogData = this.logData;
  this.sortData(this.sortInfo ?? { active: 'startTime', direction: 'desc' });
}

  countSuccess(data): any {
    let count = 0;
    data?.components?.forEach(element => {
      if (element.status === translate('INSTANCE_STATUS.SUCCESS')) {
        count = count + 1;
      }
    });
    return count;
  }

  countFailure(data): any {
    let count = 0;
    data?.components?.forEach(element => {
      if (element.status === translate('INSTANCE_STATUS.FAILED')) {
        count = count + 1;
      }
    });
    return count;
  }


  sortData(event): void {
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    if (this.deploymentLog) {
      this.sortInfo = event;
      if (this.filteredDeploymentLog?.length >= 0) {
        this.filteredDeploymentLog = this.sortDeployData(event, this.filteredDeploymentLog);
      } else {
        this.deploymentLogData = this.sortDeployData(event);
      }
      this.expandedElement = null;
      const data = this.filteredDeploymentLog ? this.filteredDeploymentLog : this.deploymentLogData;
      this.dataSourceLog = new MatTableDataSource(data?.slice(this.pageIndex, this.paginationSize));
    }
  }

  sortDeployData(event, filteredList?): any {
    let data;
    if (this.deploymentLog) {
      data = this.deploymentLogData;
    }
    if (filteredList) {
      data = filteredList;
    }
    return data?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'startTime':
          comparatorResult = a?.startTime && b?.startTime ? a?.startTime?.localeCompare(b?.startTime) : !a?.startTime ? -1 : 1;
          break;
        case 'finishTime':
          comparatorResult = a?.finishTime && b?.finishTime ? a?.finishTime?.localeCompare(b?.finishTime) : !a?.finishTime ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
    });
  }
  onArrowClick(data): void {
     if (!data) {
      this.expandedElement = null;
      this.dataSourceInnerLog = [];

      this.logData.forEach(item => {
        item.arrowClick = false;
      });
      return;
    }

  const row = this.logData.find(
    item => item.contextId === data.contextId
  );

  if (!row) {
    return;
  }

  const isCollapsing = this.expandedElement?.contextId === row.contextId;

  this.logData.forEach(item => {
    item.arrowClick = false;
  });

  if (isCollapsing) {
    this.expandedElement = null;
    this.dataSourceInnerLog = [];
  } else {
    row.arrowClick = true;
    this.expandedElement = row;
    this.fetchActivityDetail(row.contextId,row);
  }

  if (this.tableRef) {
    this.tableRef.expandedElement =
      this.expandedElement;

    this.tableRef.dataSourceInnerLog =
      this.dataSourceInnerLog;
  }

  setTimeout(() => {
    const overlays = document.querySelectorAll('.cdk-overlay-pane');
    overlays.forEach((pane: HTMLElement) => {
      if (pane.querySelector('mat-menu')) {
        pane.style.display = this.expandedElement ? 'none' : 'block';
      }
    });
  },200);
  }

  private fetchActivityDetail(activityId: string, row: any): void {
    row.innerLoading = true;
    this.dataSourceInnerLog = [];
    this.activityService.getInstanceActivityLogsById(this.instanceId, activityId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        detail => {
          row.innerLoading = false;
          let components = (detail?.stages ?? []).flatMap(stage =>
            (stage.components ?? []).map(c => ({
              ...c,
              name: c.name,
              version: c.version,
              start: c.start ? toUtcString(c.start) : null,
              end: c.end ? toUtcString(c.end) : null,
              status: c.status,
              componentType: c.componentType,
              health: c.health,
              stageType: stage.type,
              location: this.instance?.deploymentClass === DeploymentClass.A ? stage.location : null,
              showLocation: false
            }))
          ).sort((a, b) => {
            const order = {primary: 0,secondary: 1};
            return (order[a.location?.toLowerCase()] ?? 2) - (order[b.location?.toLowerCase()] ?? 2);
          });
          let lastLocationType: string | null = null;
          components.forEach((component: any) => {
            if (component?.location && component.location !== lastLocationType) {
              component.showLocation = true;
              lastLocationType = component.location;
            } 
          });

          row.components = components;
          this.dataSourceInnerLog = components;
        },
        error => {
          row.innerLoading = false;
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ?? error?.error?.message ?? error?.errmsg ?? translate('SERVICE.INTERNAL_SERVER_ERROR');
          this.toastrService.errMessage(message, title);
        }
      );
  }

  onRowClick(data: any): void {
    data.instanceId = this.instance.id;
    data.instanceClass = this.instance.deploymentClass;
    this.dialog.open(EnvironmentActivityPopupComponent, {
      width: '90%',
      panelClass: 'activity-dialog-panel',
      data: { ...data, instanceId: this.instance?.id },
      disableClose: false,
      autoFocus: false
    });
  }

  onLogTabChange(): any {
    this.deploymentLogData = this.logData;
    if (this.selectedActions?.length > 0) {
      this.deploymentLogData = this.logData?.filter(item => this.selectedActions?.includes(item?.action));
    } else {
      this.deploymentLogData = this.logData;
    }
    if (this.filterStartDate && this.filterEndDate) {
      this.deploymentLogData = this.deploymentLogData.filter(item => this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
        this.datePipe.transform(item.finishTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd'));
    }
    this.dataSourceLog = this.deploymentLogData;
    this.deploymentLog = true;
    if (this.sortInfo) {
      const sortedData = this.sortDeployData(this.sortInfo);
      this.dataSourceLog = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    } else {
      const sortedData = this.sortDeployData({ active: 'startTime', direction: 'desc' });
      this.dataSourceLog = new MatTableDataSource(sortedData?.slice(this.pageIndex, this.paginationSize));
    }
    this.logPaginator = true;
    this.pageIndex = 0;
  }

  logPageChanged(event): any {
    if (event.length) {
      this.expandedElement = null;
      this.logData.forEach(item => {
        item.arrowClick = false;
      });
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      if (this.deploymentLog) {
        const data = this.filteredDeploymentLog ? this.filteredDeploymentLog : this.deploymentLogData;
        const dataList = data?.slice(firstIndex, firstIndex + this.paginationSize);
        this.dataSourceLog = new MatTableDataSource(dataList);
      }
    }
  }

 // on page changed from header paginator changing the table paginator as well
  onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }

  // on page changed from table paginator changing the header paginator as well
   onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }

  // resetting header paginator on sorting
  resetPaginator() {
    this.pageIndex = 0;
    this.paginatorRef.pageIndex = 0;
  }

  // reloading the data on refresh click
  refreshClick(): void {
    this.loadActivityLogs();
  }

  // assigning search term
  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

  // assigning search results when search is updated
  searchedItems(result): void {
    this.searchedResult = result;
  }

  /**
   * display threshold details popup
   * @param data 
   */
  thresholdDetails(data: any): void {
  const isActivityInProgress = this.expandedElement?.status?.toLowerCase() === 'inprogress';
    this.dialog.open(ThresholdDialogComponent, {
      width: '566px',
      data: {
         ...data,
        title: translate('THRESHOLD_DIALOG.TITLE'),
        description: translate('THRESHOLD_DIALOG.DESCRIPTION'),
        componentName: data.name,
        startTime: data.start,
        expectedDurationMs: data.expectedDurationMs,
        disableAbort: this.instance?.lastOperation?.executionPhase === DeployStatus.ABORTING || !isActivityInProgress
      }
    }).afterClosed().subscribe(result => {
      if (result === 'abort') {
        // aborting environment action
        this.instanceService.putInstanceAbort(this.instanceId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          // updating environment header
          this.updateEnvHeader.emit();
        },
        (error) => {
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });
      }
    });
  }
}
